function splitPath(url) {
  const splitted = url.split('/');
  const p = splitted[splitted.length - 1];

  return {
    p,
    u: url.replace(p, ''),
  };
}

export function updatedAnimationData(animationData, maxIndex, imageUrl) {
  function updateAsset(item, index) {
    return index < maxIndex ? {
      ...item,
      ...splitPath(Array.isArray(imageUrl) ? imageUrl[index] : imageUrl),
    } : item;
  }

  return ({
    ...animationData,
    assets: animationData.assets.map(updateAsset),
  });
}
